import { Tooltip } from "@mui/material";
import { extractDomainFromEmail, formatStartTime } from "../../utils/utils";

const getColumns = (
  isLargeUp: boolean,
  handleViewClick: (payload: any) => void,
  handleTranscriptClick: (meetingId: string) => void,
  handleRegenerateClick: (meetingId: string) => void,
  handleReanalysisClick: (meetingId: string) => void
) => {
  return [
    {
      accessorKey: "email",
      header: "Account",
      Cell: ({ cell }: { cell: any }) => {
        const email = cell.getValue() || "";
        const account = extractDomainFromEmail(email) || "";
        return (
          <div className="truncate-table-cell-ellipsis">
            <Tooltip title={email as string}>
              <span>{account}</span>
            </Tooltip>
          </div>
        );
      },
      enableColumnFilter: false,
      enableSorting: false,
      grow: true,
      minSize: 100,
      size: 100,
    },
    {
      accessorKey: "meeting_id",
      header: "Meeting Id",
      Cell: ({ row }: { row: any }) => {
        const summary = row.original.meeting_id;

        return (
          <div className="truncate-table-cell-ellipsis">
            <Tooltip title={summary as string}>{summary}</Tooltip>
          </div>
        );
      },
      enableColumnFilter: false,
      enableSorting: false,
      grow: true,
      minSize: 130,
      size: 130,
    },
    {
      accessorKey: "summary",
      header: "Meeting Title",
      Cell: ({ row }: { row: any }) => {
        const summary = row.original.summary;
        return (
          <div className="truncate-table-cell-ellipsis">
            <Tooltip title={summary as string}>{summary}</Tooltip>
          </div>
        );
      },
      enableColumnFilter: false,
      enableSorting: false,
      grow: true,
      minSize: 130,
      size: 130,
    },
    {
      accessorKey: "start_time",
      header: "Date",
      Cell: ({ cell }: { cell: any }) => {
        const start_time = cell.getValue() || "";
        const [formattedDate, formattedTime] = formatStartTime(start_time);
        return (
          <div className="truncate-table-cell-ellipsis">
            {formattedDate && formattedTime
              ? `${formattedDate}, ${formattedTime}`
              : "N/A"}
          </div>
        );
      },
      enableColumnFilter: false,
      enableSorting: false,
      grow: true,
      minSize: 150,
      size: 150,
    },
    {
      accessorKey: "meetingid",
      header: "Transcript",
      Cell: ({ row }: { row: any }) => {
        const meetingId = row.original.meeting_id;
        return (
          <div className="flex items-center justify-center">
            <button
              className="bg-blue-500 text-white px-3 py-1 rounded hover:bg-blue-600"
              onClick={() => {
                handleTranscriptClick(meetingId);
              }}
            >
              View
            </button>
          </div>
        );
      },
      enableColumnFilter: false,
      enableSorting: false,
      grow: true,
      minSize: 90,
      size: 90,
    },
    {
      accessorKey: "payload",
      header: "Summary",
      Cell: ({ cell }: { cell: any }) => {
        const payload = cell.getValue();
        return (
          <div className="flex items-center justify-center">
            <button
              className="bg-blue-500 text-white px-3 py-1 rounded hover:bg-blue-600"
              onClick={() => handleViewClick(payload)}
            >
              View
            </button>
          </div>
        );
      },
      enableColumnFilter: false,
      enableSorting: false,
      grow: true,
      minSize: 90,
      size: 90,
    },
    {
      accessorKey: "run",
      header: "Re-run",
      Cell: ({ row }: { row: any }) => {
        const meetingId = row.original.meeting_id;
        const reanalysis_exist = row.original.reanalysis_exist;
        return (
          <div className="flex items-center justify-center">
            <button
              className={`px-3 py-1 rounded ${
                reanalysis_exist
                  ? "bg-gray-400 cursor-not-allowed"
                  : "bg-blue-500 hover:bg-blue-600 text-white"
              }`}
              onClick={() =>
                !reanalysis_exist && handleRegenerateClick(meetingId)
              }
              disabled={reanalysis_exist}
            >
              Re-run
            </button>
          </div>
        );
      },
      enableColumnFilter: false,
      enableSorting: false,
      grow: true,
      minSize: 100,
      size: 100,
    },
    {
      accessorKey: "re-analysis",
      header: "Re-Analysis",
      Cell: ({ row }: { row: any }) => {
        const meetingId = row.original.meeting_id;
        const reanalysis_exist = row.original.reanalysis_exist;
        if (!reanalysis_exist) return null;
        return (
          <div className="flex items-center justify-center">
            <button
              className="px-3 py-1 rounded bg-blue-500 hover:bg-blue-600 text-white"
              onClick={() => handleReanalysisClick(meetingId)}
            >
              View
            </button>
          </div>
        );
      },
      enableColumnFilter: false,
      enableSorting: false,
      grow: true,
      minSize: 90,
      size: isLargeUp ? 90 : 90,
    },
  ];
};

export { getColumns};
